// Import action types related to input search value
import {
  INPUT_VALUE_ARE_LOADING,
  INPUT_VALUE_FETCH_DATA_SUCCESS,
  INPUT_VALUE_HAVE_ERROR,
} from "../actionType";

// Define the initial state for the input search reducer
const initialState = {
  data: [], // Initialize data as an empty array
  loading: true, // Set loading to true initially
  error: [], // Initialize error as an empty array
};

// Reducer function to handle input search value-related actions and update state accordingly
export function inputSearchReducer(state = initialState, action) {
  switch (action.type) {
    // Handle error case when fetching input search value
    case INPUT_VALUE_HAVE_ERROR:
      return {
        ...state,
        error: action.hasError, // Update the error state with the error from the action
        loading: false, // Set loading to false since the request is complete
      };

    // Handle loading state when input search value is being fetched
    case INPUT_VALUE_ARE_LOADING:
      return {
        ...state,
        loading: action.isLoading, // Update the loading state with the loading status from the action
      };

    // Handle success case when input search value is successfully fetched
    case INPUT_VALUE_FETCH_DATA_SUCCESS:
      return {
        ...state,
        data: action.inputSearch, // Update the data state with the fetched input search value
        loading: false, // Set loading to false since the request is complete
        error: [], // Clear any previous errors (assuming the success case means no error)
      };

    // Return the current state by default if action type is not recognized
    default:
      return state;
  }
}
